// extracted by mini-css-extract-plugin
export default {"errorPage":"errorPage--dbFKw","errorContainer":"errorContainer--DTiMX","link":"link--VxEH9"};